import Keycloak, {KeycloakConfig, KeycloakProfile, KeycloakPromise} from "keycloak-js";
import axios from "axios";

export interface AttributedKeycloakProfile extends KeycloakProfile {
    attributes: {
        locale: string[]
    }
}

export class AuthService {
    private readonly _keyCloakRealm: string | undefined;
    private readonly _keyCloakClientId: string | undefined;
    private readonly _keyCloakUrl: string | undefined;

    private _keyCloakConfig: string | KeycloakConfig | undefined;

    private _keyCloak: Keycloak | null = null;

    constructor() {
        this._keyCloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
        this._keyCloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
        this._keyCloakUrl = process.env.REACT_APP_KEYCLOAK_URL;

        this.createKeyCloakConfig();
        this.createKeyCloakClient();
    }

    private createKeyCloakConfig() {
        this._keyCloakConfig = {
            "realm": this._keyCloakRealm as string,
            "clientId": this._keyCloakClientId as string,
            "url": this._keyCloakUrl,
        }
    }

    private createKeyCloakClient() {
        this._keyCloak = new Keycloak(this._keyCloakConfig)
    }

    get keyCloak(): Keycloak {
        return this._keyCloak as Keycloak;
    }

    public async login(): Promise<AttributedKeycloakProfile | null> {
        const authenticated = await this.keyCloak.init({
            onLoad: "login-required"
        });

        if (!authenticated) {
            this.keyCloak.login();
        }

        return this.loadUserProfile();
    }

    public async loadUserProfile() {
        return this.keyCloak.loadUserProfile() as KeycloakPromise<AttributedKeycloakProfile, void>;
    }

    public async refreshAccessToken() {
        const refreshed = await this.keyCloak.updateToken(5);
        return new Promise((resolve) => { resolve(refreshed) });
    }

    public async logout() {
        return axios.create({
            baseURL: process.env.REACT_APP_FO_HOST,
            withCredentials: true,
        }).get('/logout')
                .finally(() => this.keyCloak.logout());
    }
}